// @flow

// Отправляет на СБЛ мобильный телефон в формате '9999999999'
// Например: '+7 (123) 456-78-90' => '1234567890'
const mobilePhoneToJSMap = (p: ?string | ?number) =>
	p && (String(p)).replace(/\D+/g, '').slice(-10);

// Принимает от СБЛ мобильный телефон в формате '9999999999' и переводит его в '+7 (999) 999-99-99'
// Например: '1234567890' => '+7 (123) 456-78-90'
const mobilePhoneFromJSMap = (p: ?string) => {
	if (!p) {
		return p;
	}

	const match = /^(\d{3})(\d{3})(\d{2})(\d{2})$/.exec(p.replace(/\D/g, ''));

	if (!match) {
		return p;
	}

	const [ /*ignored*/, triple1, triple2, pair1, pair2 ] = match;

	return `+7 (${triple1}) ${triple2}-${pair1}-${pair2}`;
};

const mobilePhoneToFromJSExtend = {
	toJSMap: mobilePhoneToJSMap,
	fromJSMap: mobilePhoneFromJSMap,
};

export {
	mobilePhoneToJSMap,
	mobilePhoneFromJSMap,
	mobilePhoneToFromJSExtend,
};
